import React from 'react';
import { Button } from 'src/@/components/ui/button';
import { Badge } from 'src/@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/@/components/ui/tooltip';
import Iconify from 'src/components/Iconify';

// ----------------------------------------------------------------------

const NewMessagesButton = ({ 
  newMessagesCount, 
  onScrollToBottom, 
  isVisible = false 
}) => {

  if (!isVisible || newMessagesCount === 0) {
    return null;
  }

  return (
    <div
      className="fixed bottom-36 z-50 ml-2 animate-bounce"
    >
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              onClick={onScrollToBottom}
              className="relative w-8 h-8 rounded-full bg-purple-500 text-primary-foreground shadow-lg hover:bg-primary/90 hover:scale-110 transition-all duration-200 p-0"
            >
              <Badge 
                className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center"
              >
                {newMessagesCount}
              </Badge>
              <Iconify 
                icon="material-symbols:keyboard-arrow-down" 
                width={24} 
                height={24} 
              />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{newMessagesCount} nova{newMessagesCount > 1 ? 's' : ''} mensagem{newMessagesCount > 1 ? 's' : ''}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default NewMessagesButton;

